import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PositionsDialogsOpener } from '@core/tellent-positions-contracts';
import { TellentPosition } from '@core/tellent-positions-types';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { DeletePositionDialogComponent } from '../delete-position-dialog/delete-position-dialog.component';
import { PositionDetailsDialogComponent } from '../position-details-dialog/position-details-dialog.component';
import { RenamePositionDialogComponent } from '../rename-position-dialog/rename-position-dialog.component';

@Injectable()
export class PositionsDialogsService implements PositionsDialogsOpener {
  private readonly dialog = inject(DialogService);

  public openPositionDetails(positionGuid: string): void {
    this.dialog.openCustom(
      PositionDetailsDialogComponent,
      { width: DialogWidth.Medium },
      { positionGuid },
    );
  }

  public openRenamePositionDialog(positionGuid: string): Observable<any> {
    return this.dialog.openCustom(
      RenamePositionDialogComponent,
      { width: DialogWidth.SmallX },
      { positionGuid },
    ).afterClosed;
  }

  public openDeletePositionDialog(position: TellentPosition): Observable<any> {
    return this.dialog.openCustom(
      DeletePositionDialogComponent,
      { width: DialogWidth.SmallXX },
      { position },
    ).afterClosed;
  }
}
